<template>
  <v-list class="list">
    <v-list-item-group v-model="selectedPatient" color="teal">
      <v-list-item
        v-for="(patient, i) in patients"
        :key="i"
        @click="handlePatientProfile(i)"
      >
        <v-list-item-content>
          <v-list-item-title>
            <span class="font-weight-bold">{{
              `${patient.firstname} ${patient.lastname}`
            }}</span>
            {{
              `, ${Math.floor(
                (new Date().getTime() - new Date(patient.birthdate).getTime()) /
                  31536000000
              )}`
            }}</v-list-item-title
          >
          <v-list-item-subtitle class="text--primary">
            {{ patient.email }}
          </v-list-item-subtitle>
        </v-list-item-content>
        <v-list-item-action>
          <v-tooltip top>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                fab
                small
                @click="newAppoint"
                v-on="on"
                v-bind="attrs"
                elevation="1"
              >
                <v-icon>mdi-clipboard-plus-outline</v-icon>
              </v-btn>
            </template>
            <span>Kreiraj izvestaj</span>
          </v-tooltip>
        </v-list-item-action>
      </v-list-item>
    </v-list-item-group>
  </v-list>
</template>

<script>
export default {
  props: ["patients"],
  data() {
    return {
      selectedPatient: "",
    };
  },
  methods: {
    handlePatientProfile(index) {
      this.$emit("clickProfile", index);
    },
    newAppoint(e) {
      console.log("ayo");
      e.stopPropagation();
    },
  },
};
</script>

<style scoped>
.list {
  height: 100%;
}
</style>
